module.exports = __webpack_public_path__ + "img/65.fda52bba.png";